<template>
  <div class="page-logout com_bg2">
    <div id="wrapper1">
      <img
        :src="logoutImage"
        :alt="altText"
        class="with-kaunet_logo-logout"
        style="margin-top: 0"
      />

      <h2 class="com_mgb45 com_mgt100 com_fs26 com_medium1 com_center1">
        ログアウトしました
      </h2>

      <router-link to="/login" class="com_button1">ログインページ</router-link>
      <p class="com_copyright1 com_mgt100">© 2025 Kaunet</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "LogoutComponent",

  setup() {
    // --- システム区分に応じてログイン画像を切替（ビルド時に展開される） ---
    const STYLE_MAP: Record<string, string> = {
      "01": require("@/assets/common/img/01/with-kaunet_logo-logout.png"),
      "02": require("@/assets/common/img/02/with-kaunet_logo-logout.png"),
      "03": require("@/assets/common/img/03/with-kaunet_logo-logout.png"),
    };

    const STYLE_ALT_MAP: Record<string, string> = {
      "01": "ウィズカウネット エージェントポータル",
      "02": "ベースカウネット エージェントポータル",
      "03": "サプライヤーポータル",
    };

    const systemKbn = process.env.VUE_APP_SYSTEM_KBN;
    const logoutImage = STYLE_MAP[systemKbn];
    const altText = STYLE_ALT_MAP[systemKbn];

    return {
      logoutImage,
      altText,
    };
  },
});
</script>
<style scoped>
.page-logout #wrapper1 {
  /* グレー背景のまま、全体を少し下げる */
  padding-top: 30px; /* ←好きな高さに調整 */
}
</style>
